import {
  // REQUEST_PORTFOLIO_PACKAGES,
  RECEIVE_PORTFOLIO_PACKAGES,
  // RECEIVE_PORTFOLIO_PACKAGES_FAILED
} from '../actions/types'

const INITIAL_STATE = {}

export default function(state = INITIAL_STATE, action) {
  switch (action.type) {
    case RECEIVE_PORTFOLIO_PACKAGES:
      let items = {}
      let ids = []

      for (let value of action.payload) {
        items[value.id] = value
        ids.push(value.id)
      }

      return {
        ...state,
        [action.portfolio_id]: {
          loading: false,
          items: items,
          ids: ids,
        },
      }

    // no default
  }
  return state
}
